/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'send': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M2 21l21-9L2 3v7l15 2-15 2v7z"/>'
  }
})
